import React, { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import moment from 'moment';
import 'moment/locale/pt-br';

import Config from '../../../../../../../../../../controllers/config';
import {
    getDatasEntregas,
    getPedidosConcluidos,
} from '../../../../../../../../../../controllers/gerenciarPedidos';

import CollapseList from '../childrens/collapseList/.mixins/collapseList';
import Paginacao from '../../../../../../../../../util/paginacao/.mixins/paginacao';
import SearchPedido from '../../../../../../../../../util/searchPedido/.mixins/index';
import OpcoesBuscaPopoverAllFilter from '../../../../../../../../../util/opcoesBuscaPopoverAllFilters/.mixins/index';

import { TokenValidation } from '../../../../../../../../../util/Helpers/TokenValidation';
import { ErrorHandling } from '../../../../../../../../../util/Helpers/ErrorHandling';

export default (props) => {
    const {
        dataEntregaConcluida: dataEntrega,
        fornecedor,
        firstLoad,
        opcoesFilial
    } = props.state;

    const {
        setState,
        childAlerta,
    } = props;

    const [isAtivaFilter, setIsAtivaFilter] = useState(false);

    //Paginação
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalRows, setTotalRows] = useState(0);
    const rowsPerPageOptions = [5, 10, 25, 50, 100];

    //SearchPedido
    const [searchFieldExternal, setSearchFieldExternal] = useState('');
    const [dtInitial, setDtInitial] = useState(moment().toDate());
    const [dtEnd, setDtEnd] = useState(moment().add(30, 'days').toDate());

    //OpcoesBusca
    const [searchField, setSearchField] = useState('');
    const [colunasOpcoesDeBusca, setColunasOpcoesDeBusca] = useState([
        {
            key: 'Número do Pedido',
            value: false,
        },
        {
            key: 'ID Produto',
            value: false,
        },
        {
            key: 'Código Numérico',
            value: false,
        },
        {
            key: 'Nome do Produto',
            value: false,
        },
    ]);

    //OpcoesBuscaTags
    const [colunasFilterTags, setColunasFilterTags] = useState([
        {
            key: 'Número do Pedido',
            value: '',
            origemValue: ""
        },
        {
            key: 'ID Produto',
            value: '',
            origemValue: ""
        },
        {
            key: 'Código Numérico',
            value: '',
            origemValue: ""
        },
        {
            key: 'Nome do Produto',
            value: '',
            origemValue: ""
        },
        {
            key: "Data de agendamento",
            value: "",
            origemValue: ""
        },
        {
            key: 'Filial',
            value: '',
            origemValue: ""
        },
    ]);

    const [escolhaFilial, setEscolhaFilial] = useState({ id:0, name: "Selecione uma filial" });

    const dateFormat = (date) => {
        return moment(date).format('DD/MM/YYYY');
    };

    const handlerChangeDateInitial = async (value) => {
        setDtInitial(value);
        let newColunasFilterTags = colunasFilterTags;
        newColunasFilterTags[4].value = `${dateFormat(value)} - ${dateFormat(dtEnd)}`;
        setColunasFilterTags(newColunasFilterTags);
    };

    const handlerChangeDateEnd = async (value) => {
        setDtEnd(value);
        let newColunasFilterTags = colunasFilterTags;
        newColunasFilterTags[4].value = `${dateFormat(dtInitial)} - ${dateFormat(value)}`;
        setColunasFilterTags(newColunasFilterTags);
    };

    const loadInit = async () => {
        await handlerCleanFilters();
        await loadDataEntregaConcluida({ linha_inicial: 0, qtd_registro: rowsPerPage, tipo_load: 'firstLoad' });
    };

    useEffect(() => {
        loadInit();
    }, [fornecedor]);

    useEffect(() => {
        loadDataEntregaConcluida({ linha_inicial: 0, qtd_registro: rowsPerPage, tipo_load: 'rowsPerPage' });
    }, [rowsPerPage]);

    useEffect(() => {
        loadDataEntregaConcluida({ linha_inicial: 0, qtd_registro: rowsPerPage, tipo_load: 'isAtivaFilter' });
        setIsAtivaFilter(false);
    }, [isAtivaFilter,setIsAtivaFilter]);

    //Paginação - Functions
    const onChangePage = (pageFrom) => {
        loadDataEntregaConcluida({ linha_inicial: pageFrom, qtd_registro: rowsPerPage, tipo_load: 'onchange' });
    };

    //OpcoesBusca - Functions()
    const handlerClickCheckbox = async (i) => {
        const coluns = colunasOpcoesDeBusca.map((coluna, index) => {
            return index === i ? { ...coluna, value: !coluna.value } : coluna;
        });
        await setColunasOpcoesDeBusca(coluns);
        await handlerChangeSearchFilterTag(i,coluns);
    };

    const handlerChangeSearchFilterTag = async (i,coluns) => {
        let newColunasFilterTags = colunasFilterTags;

        const nameObject = coluns[i].key;
        const indexObject = colunasFilterTags.map(e=>e.key).indexOf(nameObject);

        if (indexObject < 0) return;
        
        if (coluns[i].value) {
            newColunasFilterTags[indexObject].value = searchField;
        } else {
            newColunasFilterTags[indexObject].value = "";
        }
        // sem essa conversão não renderiza o array tags
        await setColunasFilterTags(JSON.parse(JSON.stringify(newColunasFilterTags)));
    };

    const handleChangeSearchFieldOpcoesBusca = (event) => {
        event.persist();
        setSearchField(event.target.value);
    };

    //OpcoesBuscaPopover - Functions()
    const handlerCleanFilters = async () => {
        await setState({firstLoad: true})
        setSearchField('');
        setSearchFieldExternal('');
        setDtInitial(moment().toDate());
        setDtEnd(moment().add(30, 'days').toDate());
        setEscolhaFilial({ id:0, name: "Selecione uma filial" });

        setColunasOpcoesDeBusca(
            colunasOpcoesDeBusca.map((coluna) => {
                coluna.value = false;
                return coluna;
            })
        );

        setColunasFilterTags(
            colunasFilterTags.map((coluna) => {
                coluna.value = '';
                return coluna;
            })
        );

        loadDataEntregaConcluida({ linha_inicial: 0, qtd_registro: rowsPerPage, tipo_load: 'applyFilters' });
        
        await setState({firstLoad: false})
    };

    const handlerAplicarFilters = async () => {
        await setState({firstLoad: true})
        const index = colunasOpcoesDeBusca.findIndex(
            (coluna, index) => coluna.value === true && colunasFilterTags[index].value === ''
        );

        setColunasFilterTags(
            colunasFilterTags.map((coluna, i) => {
                return i === index ? { ...coluna, value: searchField } : coluna;
            })
        );

        setSearchField('');

        loadDataEntregaConcluida({ linha_inicial: 0, qtd_registro: rowsPerPage, tipo_load: 'applyFilters' });
        
        await setState({firstLoad: false})
    };

    //OpcoesBuscaTags - Functions()
    const handlerClearFilterTag = async (i) => {
        await setColunasFilterTags(
            colunasFilterTags.map((coluna, index) => {
                return index === i ? { ...coluna, value: '' } : coluna;
            })
        );

        await setColunasOpcoesDeBusca(
            colunasOpcoesDeBusca.map((coluna, index) => {
                return index === i ? { ...coluna, value: false } : coluna;
            })
        );
        
        await setIsAtivaFilter(true);
    };

    //SearchPedido - Functions
    const handleChangeSearchFieldPedido = (event) => {
        setSearchFieldExternal(event.target.value);
    };

    const handleClickSearchField = () => {
        childAlerta.current.retorno(`Pedido: ${searchFieldExternal}`, 'info');
    };

    const handleChange = async (element) => {
        const index = dataEntrega.indexOf(element);
        dataEntrega[index].isOpen = !element.isOpen;

        if (dataEntrega[index].isOpen === true && !element.data) {
            const pedidosConcluidos = await loadDataPedidosConcluidos(element);
            dataEntrega[index].data = pedidosConcluidos;
        }
        props.heandleExtendChangeEntregaConcluida(dataEntrega);
    };

    const loadDataPedidosConcluidos = async (element) => {
        setState({ isLoading: true });
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        const [date] = element.DT_ENTRG.split(' ');

        const filters = {
            idPessoa: fornecedor,
            dtEntrega: date,

            nrPc: colunasFilterTags[0].value,
            idProd: colunasFilterTags[1].value,
            cdNum: colunasFilterTags[2].value,
            dsProd: colunasFilterTags[3].value,
            cdFil: colunasFilterTags[5].value,
        };

        const pedidosConcluidos = await getPedidosConcluidos(token, filters)
            .then((response) => {
                const pedidos = JSON.parse(response.body);
                const statusCode = response.res.statusCode;

                if (statusCode !== 200) {
                    TokenValidation(pedidos.status, pedidos.message, childAlerta);
                }

                setState({ isLoading: false });
                return pedidos;
            })
            .catch((error) => {
                ErrorHandling(error, Config, setState, childAlerta);
            });

        return pedidosConcluidos;
    };

    const isInt = (value) => {
        return !isNaN(value) && 
        parseInt(Number(value)) == value && 
        !isNaN(parseInt(value, 10));
    };

    const loadDataEntregaConcluida = async ({ linha_inicial, qtd_registro, tipo_load }) => {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        let nr_pc = null;
        let id_prod = null;
        let cd_num = null;
        let nm_prod = null;
        let cd_fil = "";

        const arrayColNrPcTag = colunasFilterTags
        .filter(element => (
            element.key === "Número do Pedido" &&
            element.value !== element.origemValue
        ));

        const arrayColNrProdTag = colunasFilterTags
        .filter(element => (
            element.key === "ID Produto" &&
            element.value !== element.origemValue
        ));

        const arrayColCdNumTag = colunasFilterTags
        .filter(element => (
            element.key === "Código Numérico" &&
            element.value !== element.origemValue
        ));

        const arrayColDsProdTag = colunasFilterTags
        .filter(element => (
            element.key === "Nome do Produto" &&
            element.value !== element.origemValue
        ));

        const arrayColFilialTag = colunasFilterTags
        .filter(element => (
            element.key === "Filial" &&
            element.value !== element.origemValue
        ));

        const arrayDatasTags = colunasFilterTags
        .filter(element => (
            element.key === "Data de agendamento" &&
            element.value !== element.origemValue
        ));

        if (arrayColNrPcTag.length > 0) {
            nr_pc = parseInt(arrayColNrPcTag[0].value);

            if (!isInt(nr_pc)) {
                props.childAlerta.current.retorno('Campo precisa ser um número!','warning');
                return;
            }
        }

        if (arrayColNrProdTag.length > 0) {
            id_prod = parseInt(arrayColNrProdTag[0].value);

            if (!isInt(id_prod)) {
                props.childAlerta.current.retorno('Campo precisa ser um número!','warning');
                return;
            }
        }

        if (arrayColCdNumTag.length > 0) {
            cd_num = parseInt(arrayColCdNumTag[0].value);

            if (!isInt(cd_num)) {
                props.childAlerta.current.retorno('Campo precisa ser um número!','warning');
                return;
            }
        }

        if (arrayColDsProdTag.length > 0 && !isInt(searchField)) {
            nm_prod = arrayColDsProdTag[0].value;
        }

        if (arrayColFilialTag.length > 0) {
            cd_fil = arrayColFilialTag[0].value;
        }
        
        if (tipo_load == "searchField") {
            if (isInt(searchFieldExternal)){
                nr_pc = searchFieldExternal;
            } else {
                nm_prod = searchFieldExternal;
            }
        } else if (tipo_load == "applyFilters") {
            if (
                arrayColNrPcTag.length == 0 &&
                arrayColNrProdTag.length == 0 &&
                arrayColCdNumTag.length == 0 &&
                arrayColDsProdTag.length == 0 &&
                searchField != ""
            ) {
                setSearchField("");
            }
        }

        let dtInitialp, dtEndp = null;
        if (arrayDatasTags.length > 0) {
            dtInitialp = moment(dtInitial).format("DD/MM/YYYY");
            dtEndp = moment(dtEnd).format("DD/MM/YYYY");
        }

        const filters = {
            idPessoa: fornecedor,
            linhaInicial: linha_inicial,
            qtdRegistro: qtd_registro,

            nrPc: nr_pc,
            idProd: id_prod,
            cdNum: cd_num,
            dsProd: nm_prod,

            cdFil: (cd_fil === "")?null:escolhaFilial.id,
            DtEntregaInic: dtInitialp,
            DtEntregaFim: dtEndp,
        };

        await getDatasEntregas(token, filters)
            .then((response) => {
                let datas = JSON.parse(response.body);
                const statusCode = response.res.statusCode;

                if (statusCode !== 200) {
                    TokenValidation(datas.status, datas.message, childAlerta);
                }

                datas = datas.map((data) => {
                    return {
                        ...data,
                        isOpen: false,
                    };
                });

                setState({dataEntregaConcluida: datas});
                setTotalRows(datas.length > 0 ? datas[0].QT_TOTAL_REGS:0);
            })
            .catch((error) => {
                ErrorHandling(error, Config, setState, childAlerta);
            });
    };

    const handlerEscolhaFilialSetTag = async (value) => {
        let newColunasFilterTags = colunasFilterTags;

        const indexObject = colunasFilterTags
            .map(e=>e.key)
            .indexOf("Filial");
        if (indexObject < 0) return;
        
        if (value.id > 0)
            newColunasFilterTags[indexObject].value = value.id;
        else
            newColunasFilterTags[indexObject].value = "";

        await setColunasFilterTags(JSON.parse(JSON.stringify(newColunasFilterTags)));
    };

    const handlerChangeEscolhaFilial = async (value) => {
        await setEscolhaFilial(value);
        await handlerEscolhaFilialSetTag(value);
    };

    return (
        <>
            {/* <SearchPedido
                state={{ searchField: searchFieldExternal }}
                handleChangeSearchFieldPedido={handleChangeSearchFieldPedido}
                handleClickSearchField={handleClickSearchField}
            /> */}

            <OpcoesBuscaPopoverAllFilter
                searchField={searchField}
                dtInitial={dtInitial}
                dtEnd={dtEnd}
                escolhaData={"Data entrega"}
                isColunasMultiple={true}
                isFixed={true}
                opcoesFilial={opcoesFilial}
                escolhaFilial={escolhaFilial}
                buttonVariant={'text'}
                btLabel={'OPÇÕES DE BUSCA'}
                
                colunas={colunasOpcoesDeBusca}
                colunasFilterTags={colunasFilterTags}

                handlerClickCheckbox={handlerClickCheckbox}
                handleChangeSearchFieldPedido={handleChangeSearchFieldOpcoesBusca}

                handlerCleanFilters={handlerCleanFilters}
                handlerAplicarFilters={handlerAplicarFilters}
                
                handlerClearFilterTag={handlerClearFilterTag}

                handlerChangeDateInitial={handlerChangeDateInitial}
                handlerChangeDateEnd={handlerChangeDateEnd}
                handlerChangeEscolhaFilial={handlerChangeEscolhaFilial}
            />

            {dataEntrega.map((element, i) => {
                return <CollapseList key={i} element={element} handleChange={handleChange} />;
            })}

            <Paginacao
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                totalRows={totalRows}
                rowsPerPageOptions={rowsPerPageOptions}
                onChangePage={onChangePage}
                firstLoad={firstLoad}
            />
        </>
    );
};
